/*
 * Created on Tue Jul 30 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

import { StringHelper } from "@root/core/utilities/string-helper";

enum EEnvironment {
    ReactNative,
    NodeJS,
    Browser,
}

function getRunningEnvironment(): EEnvironment {
    /// test react native
    if (navigator && navigator.product === "ReactNative") return EEnvironment.ReactNative;

    /// test browser
    if (window && document) return EEnvironment.Browser;

    /// test nodejs
    var isNode = false;
    // Export the Underscore object for **CommonJS**, with backwards-compatibility
    // for the old `require()` API. If we're not in CommonJS, add `_` to the
    // global object.
    if (typeof module !== "undefined" && module.exports) isNode = true;
    if (isNode) return EEnvironment.NodeJS;

    throw "Detect running environment failed.";
}

interface CoreOptions {
    url: string;
    method?: "GET" | "PATCH" | "POST" | "PUT" | "DELETE" | "OPTIONS";
    json?: boolean;
    body?: any;
    headers?: any;
}

interface RequestResult {
    statusCode: number;
}

interface RequestCallback {
    (err: any, res?: RequestResult, body?: any): void;
}

let runningEnvironment = getRunningEnvironment();
export function request(options: CoreOptions, callback?: RequestCallback) {
    switch (runningEnvironment) {
        case EEnvironment.Browser:
        case EEnvironment.ReactNative:
            let { url, json } = options;
            const body = options.body;
            const isFormData =
                typeof FormData !== "undefined" && body instanceof FormData;
            const isBlob = typeof Blob !== "undefined" && body instanceof Blob;
            const isArrayBuffer =
                typeof ArrayBuffer !== "undefined" && body instanceof ArrayBuffer;
            const isUrlParams =
                typeof URLSearchParams !== "undefined" &&
                body instanceof URLSearchParams;

            if (
                !isFormData &&
                !isBlob &&
                !isArrayBuffer &&
                !isUrlParams &&
                typeof body !== "string"
            ) {
                options.body = JSON.stringify(body);
            }
            fetch(url, options)
                .then(async (resp) => {
                    const contentType: string = resp.headers.get(
                        "Content-Type",
                    ) as string;
                    const isJson = json || /^application\/json/i.test(contentType);
                    const isText = /^text\//i.test(contentType);

                    let data = isJson
                        ? StringHelper.toObject(await resp.text())
                        : isText
                          ? await resp.text()
                          : await resp.blob();

                    const statusCode = resp.status;
                    callback && callback(null, { statusCode }, data);
                })
                .catch((err) => {
                    callback && callback(err);
                });

            break;

        case EEnvironment.NodeJS:
            //let request = require('request');
            let request: any;
            request(options, callback);
            break;
    }
}
